module.exports = __webpack_public_path__ + "img/SEND_MESSAGE.3d8cea78.svg";